export const LOAD_STREAMS_LIST_SUCCESS = 'LOAD_STREAMS_LIST_SUCCESS';
export const LOAD_STREAMS_LIST_FAILURE = 'LOAD_STREAMS_LIST_FAILURE';
export const LOAD_STREAMS_LIST_REQUEST = 'LOAD_STREAMS_LIST_REQUEST';

export const BULK_DELETE_STREAMS_SUCCESS = 'BULK_DELETE_STREAMS_SUCCESS';
export const BULK_DELETE_STREAMS_FAILURE = 'BULK_DELETE_STREAMS_FAILURE';
export const BULK_DELETE_STREAMS_REQUEST = 'BULK_DELETE_STREAMS_REQUEST';


